export const FUNDING_INFO_STEP = {
  name: 'Funding information',
  link: '/client-account/payment-details/funding-info',
  isShown: true,
  status: false,
  key: 'fundingInfo',
} as const;

export const VERIFY_PAYMENT_STEP = {
  name: 'How to verify your payment',
  link: '/client-account/payment-details/how-to-verify',
  isShown: true,
  status: false,
  key: 'verifyPayment',
} as const;

export const UPLOAD_NDIS_LETTER_STEP = {
  name: 'Upload NDIS letter',
  link: '/client-account/payment-details/upload-ndis-letter',
  isShown: true,
  status: false,
  key: 'uploadNDIS',
} as const;

export const NDIS_NUMBER_STEP = {
  name: 'NDIS Number',
  link: '/client-account/payment-details/ndis-number',
  isShown: true,
  status: false,
  key: 'NDISNumber',
} as const;

export const INVOICING_STEP = {
  name: 'Invoicing',
  link: '/client-account/payment-details/invoice',
  isShown: true,
  status: false,
  key: 'invoicing',
} as const;

export const ADD_ORGANIZATION_STEP = {
  name: "Your funding plan manager's organisation",
  link: '/client-account/payment-details/add-organization',
  isShown: true,
  status: false,
  key: 'fundingPlanManager',
} as const;

export const FUNDING_ORGANISATION_STEP = {
  name: "Your funding plan manager's organisation",
  link: '/client-account/payment-details/funding-organisation',
  isShown: true,
  status: false,
  key: 'fundingPlanManager',
} as const;

export const HOME_CARE_PACKAGE_STEP = {
  name: 'Your Support at Home funding provider',
  link: '/client-account/payment-details/home-care-package',
  isShown: true,
  status: false,
  key: 'homeCarePackage',
} as const;

export const PAYMENT_INFORMATION_STEP = {
  name: 'Payment Information',
  link: '/client-account/payment-details/funding-info',
  isShown: true,
  status: false,
  key: 'paymentInformation',
} as const;

export const ADD_CARD_STEP = {
  name: 'Add card details',
  link: '/client-account/payment-details/credit-card',
  isShown: true,
  status: false,
  key: 'addCard',
} as const;

export const DIRECT_DEBIT_STEP = {
  name: 'Direct debit details',
  link: '/client-account/payment-details/debit-card',
  isShown: true,
  status: false,
  key: 'directDebit',
} as const;

export const AUTHORISATION_FORM_STEP = {
  name: 'Authorisation form',
  link: '/client-account/payment-details/authorization-form',
  isShown: true,
  status: false,
  key: 'authorisationForm',
} as const;

export const UPLOAD_AUTHORISATION_FORM_STEP = {
  name: 'Upload authorisation form',
  link: '/client-account/payment-details/upload-authorisation-form',
  isShown: true,
  status: false,
  key: 'uploadAuthorisationForm',
} as const;

export const POWER_OF_ATTORNEY_STEP = {
  name: 'Power of attorney statement',
  link: '/client-account/payment-details/power-of-attorney-statement',
  isShown: true,
  status: false,
  key: 'powerOfAttorney',
} as const;

export const RECEIPTS_STEP = {
  name: 'Receipts',
  link: '/client-account/payment-details/invoice',
  isShown: true,
  status: false,
  key: 'invoicing',
} as const;
